(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rose-comparison-section"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT_SELECTOR = '.rtcv2t';
  const MOBILE_QUERY = '(max-width: 989px)';

  const initialize = (root) => {
    if (!root || root.dataset.rtcv2tReady === 'true') return;
    root.dataset.rtcv2tReady = 'true';

    const carousel = root.querySelector('[data-rtcv2t-carousel]');
    const cards = Array.from(root.querySelectorAll('[data-rtcv2t-card]'));
    const controls = Array.from(root.querySelectorAll('[data-rtcv2t-index]'));

    if (!carousel || cards.length === 0) return;

    const setActive = (index) => {
      controls.forEach((control) => {
        const active = Number(control.dataset.rtcv2tIndex) === index;
        control.classList.toggle('is-active', active);

        if (control.classList.contains('rtcv2t__tab')) {
          control.setAttribute('aria-selected', active ? 'true' : 'false');
        } else {
          control.setAttribute('aria-current', active ? 'true' : 'false');
        }
      });
    };

    const scrollToCard = (index) => {
      const card = cards[index];
      if (!card) return;

      if (window.matchMedia(MOBILE_QUERY).matches) {
        carousel.scrollTo({
          left: card.offsetLeft - 10,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      setActive(index);
    };

    root.addEventListener('click', (event) => {
      const control = event.target.closest('[data-rtcv2t-index]');
      if (!control || !root.contains(control)) return;
      scrollToCard(Number(control.dataset.rtcv2tIndex));
    });

    let cardObserver = null;
    let fallbackTicking = false;

    const disconnectTracking = () => {
      if (cardObserver) {
        cardObserver.disconnect();
        cardObserver = null;
      }
      carousel.removeEventListener('scroll', onFallbackScroll);
    };

    const onFallbackScroll = () => {
      if (fallbackTicking || !window.matchMedia(MOBILE_QUERY).matches) return;
      fallbackTicking = true;

      requestAnimationFrame(() => {
        const left = carousel.getBoundingClientRect().left;
        let bestIndex = 0;
        let bestDistance = Infinity;

        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - left - 10);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
          }
        });

        setActive(bestIndex);
        fallbackTicking = false;
      });
    };

    const connectTracking = () => {
      disconnectTracking();
      if (!window.matchMedia(MOBILE_QUERY).matches) {
        setActive(0);
        return;
      }

      if ('IntersectionObserver' in window) {
        cardObserver = new IntersectionObserver((entries) => {
          let bestEntry = null;

          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
              bestEntry = entry;
            }
          });

          if (bestEntry) {
            setActive(cards.indexOf(bestEntry.target));
          }
        }, {
          root: carousel,
          threshold: [0.55, 0.7, 0.85]
        });

        cards.forEach((card) => cardObserver.observe(card));
      } else {
        carousel.addEventListener('scroll', onFallbackScroll, { passive: true });
      }
    };

    connectTracking();

    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', connectTracking);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(connectTracking);
    }
  };

  const start = (root) => {
    if (!root || root.dataset.rtcv2tBoot === 'true') return;
    root.dataset.rtcv2tBoot = 'true';

    if (!('IntersectionObserver' in window)) {
      initialize(root);
      return;
    }

    const bootObserver = new IntersectionObserver((entries, observer) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      initialize(root);
    }, { rootMargin: '300px 0px' });

    bootObserver.observe(root);
  };

  const bootAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(start);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bootAll(), { once: true });
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches?.(ROOT_SELECTOR)
      ? event.target
      : event.target.querySelector?.(ROOT_SELECTOR);

    if (root) {
      root.dataset.rtcv2tBoot = 'false';
      root.dataset.rtcv2tReady = 'false';
      start(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
